import { EstateSearchProps } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';
import { useLocalstorageState } from 'rooks';

export type UseEstateSearchLocalStorageProps = {
  updateLastSearchQuery: (query: EstateSearchProps) => void;
  lastSearchQuery: EstateSearchProps | null;
};

export const useEstateSearchLocalStorage = (): UseEstateSearchLocalStorageProps => {
  // TODO: REMOVE AFTER IMMOBILIEN API INTEGRATION: switch
  const useImmobilienApi = ConfigProvider.getConfig().get('USE_IMMOBILIEN_API') === 'true';

  const [lastSearchQuery, setLastSearchQuery] = useLocalstorageState<EstateSearchProps | null>(
    `search_lastSearchQuery_${useImmobilienApi ? 'immobilien' : 'sip'}`,
    null
  );

  const updateLastSearchQuery = (query: EstateSearchProps) => {
    setLastSearchQuery(query);
  };

  return {
    updateLastSearchQuery,
    lastSearchQuery,
  };
};
